import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'sweetalert2/dist/sweetalert2.min.js'
import '@fortawesome/fontawesome-free/css/all.min.css'
import { createHead } from '@vueuse/head'
const head = createHead()

createApp(App)
  .use(router)
  .use(i18n)
  .use(head)
  .mount('#app')
